(() => {
  if (customElements.get('partners-media-slider')) {
    return;
  }

  class PartnersMediaSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this) return;

      this.options = {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 2500, 
        },
        breakpoints: {
          767: {
            slidesPerView: 4, 
          },
          1023: {
            slidesPerView: 6,
          },
        },
      };

      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define('partners-media-slider', PartnersMediaSlider);
})();
